module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Abbreviations")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AAA")]), _vm._v(" – Anti-aircraft artillery")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ABDACOM")]), _vm._v(" – American-British-Dutch- Australian Command")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AIF")]), _vm._v(" – Australian Imperial Force")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AT")]), _vm._v(" – Anti-tank")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AWM")]), _vm._v(" – Australian War Memorial")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C-in-C")]), _vm._v(" – Commander-in-Chief")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("COS")]), _vm._v(" – Chief of Staff")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ETO")]), _vm._v(" – European Theatre of Operations")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("FEAF")]), _vm._v(" – Far Eastern Air Force")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GOC")]), _vm._v(" – General Officer Commanding")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HE")]), _vm._v(" – High explosive")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HMG")]), _vm._v(" – Heavy machine-gun")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HQ")]), _vm._v(" – Headquarters")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IJA")]), _vm._v(" – Imperial Japanese Army")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IJN")]), _vm._v(" – Imperial Japanese Navy")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("IR")]), _vm._v(" – Infantry Regiment")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("JCS")]), _vm._v(" – Joint Chiefs of Staff")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LCVP")]), _vm._v(" – Landing Craft Vehicle Personnel")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LMG")]), _vm._v(" – Light machine-gun")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("LOC")]), _vm._v(" – Lines of communication")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MG")]), _vm._v(" – Machine-gun")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MMG")]), _vm._v(" – Medium machine-gun")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("MT")]), _vm._v(" – Motor Track")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NARA")]), _vm._v(" – National Archives and Records Administration")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NEI")]), _vm._v(" – Netherlands East Indies")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PIR")]), _vm._v(" – Parachute Infantry Regiment")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("POWs")]), _vm._v(" – Prisoners-of-war")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PT")]), _vm._v(" – Patrol torpedo")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("QF")]), _vm._v(" – Quick-firing")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RAAF")]), _vm._v(" – Royal Australian Air Force")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RAN")]), _vm._v(" – Royal Australian Navy")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RCT")]), _vm._v(" – Regimental Combat Team")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("RN")]), _vm._v(" – Royal Navy")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SEAC")]), _vm._v(" – South-East Asia Command")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SMG")]), _vm._v(" – Submachine-gun")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SMLE")]), _vm._v(" – Short Magazine Lee Enfield")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SNLF")]), _vm._v(" – Special Naval Landing Force")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SWPA")]), _vm._v(" – South-West Pacific Area")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TF")]), _vm._v(" – Task Force")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("USAAF")]), _vm._v(" – United States Army Air Force")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("USAFFE")]), _vm._v(" – United States Army Forces in the Far East")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("USAMHI")]), _vm._v(" – United States Army Military History Institute")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("USMC")]), _vm._v(" – United States Marine Corps")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("USN")]), _vm._v(" – United States Navy")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("USS")]), _vm._v(" – US ship")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aeb2d32e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Abbreviations.vue
// module id = 69
// module chunks = 0